module.exports = __webpack_public_path__ + "media/images/posts/celebrate_together-9149f621346c12ae3670145614601409.jpg";